module.exports = __webpack_public_path__ + "img/icon-option.2239f6c6.svg";